import { doc, getDoc, setDoc, updateDoc } from 'firebase/firestore';
import { auth, db } from './firebase'


export async function isTeacherId(id) { // createId : string
  try {
    const idListRef = doc(db, 'original_sentence', "ID");
    const idListSnap = await getDoc(idListRef)
    const id_list = idListSnap.data().id_list;
    if (id_list.includes(id)) {
      return true;
    } else {
      return false;
    }
  } catch (err) {
    console.error("Error at createId: ", err);
  }
}
